import { isString } from 'rev-shared/util';
import { BootstrapContext } from 'rev-shared/bootstrap/BootstrapContext';
import { IMediaFeatures } from 'rev-shared/media/IMediaFeatures';
import { C2PA_RESOURCE_CONFIG } from 'rev-shared/videoPlayer/ResourceType';
import { isFirefox } from 'rev-shared/util/UserAgentUtil';

export function parseBooleanQueryParam(param: string): boolean {
	return isString(param)
		? param.trim().toLowerCase() === 'true'
		: !!param;
}

export function getEmbedPlayerConfig(queryParams: any, isParseBool?: boolean, mediaFeatures?: IMediaFeatures) {
	const defaultSubtitleLangPreferenceOrder = BootstrapContext.languagePreferenceOrder.map(lang => lang.toLowerCase());
	let forcedCCOn = isParseBool ? parseBooleanQueryParam(queryParams.forceClosedCaptions) : queryParams.forceClosedCaptions;
	if (queryParams.subtitles && isString(queryParams.subtitles)) {
		forcedCCOn = true;
		if (queryParams.subtitles !== 'auto') {
			defaultSubtitleLangPreferenceOrder.unshift(queryParams.subtitles.toLowerCase());
		}
	};
	const isLmsViewContext = queryParams?.viewContext?.toLowerCase().includes('lms');
	return {
		playerControls: {
			overlayControls: isParseBool ? !parseBooleanQueryParam(queryParams.noCenterButtons) : !queryParams.noCenterButtons,
			playControls: isParseBool ? !parseBooleanQueryParam(queryParams.noPlayBar) : !queryParams.noPlayBar,
			cc: isParseBool ? !parseBooleanQueryParam(queryParams.noCc) : !queryParams.noCc,
			settings: isParseBool ? !parseBooleanQueryParam(queryParams.noSettings): !queryParams.noSettings,
			fullscreen: isParseBool ? !parseBooleanQueryParam(queryParams.noFullscreen) : !queryParams.noFullscreen,
			chapterSeek: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterSeek) : !queryParams.noChapterSeek,
			chapterDisplay: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterDisplay) : !queryParams.noChapterDisplay,
			chapterMenu: isParseBool ? !parseBooleanQueryParam(queryParams.noChapterMenu) : !queryParams.noChapterMenu,
			disablePlaybackRate: !parseBooleanQueryParam(queryParams.allowSpeedChanges)
		},
		accentColor: queryParams.accent,
		forcedCCOn,
		subtitleLangPreferenceOrder: defaultSubtitleLangPreferenceOrder,
		seekForwardMaxTimeInSeconds: isLmsViewContext ? queryParams.startAt / 1000
			: undefined,
		c2paConfig: !isFirefox() && mediaFeatures?.enableContentCredentials ? C2PA_RESOURCE_CONFIG : undefined
	};
}
